import { createFileRoute } from '@tanstack/react-router';

import { automaticSplitPlanScreen, automaticSplitPlanSearch, loadAutomaticSplitMessages, loadAutomaticSplitScreens } from '@/modules/automatic-split/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// Plano de pagamento (`router.tsx:659-663`).
export const Route = createFileRoute('/_app/contas-digitais/split-automatico/$operationId/')({
  validateSearch: automaticSplitPlanSearch,
  staticData: { screen: automaticSplitPlanScreen },
  loader: () => loadAutomaticSplitMessages(),
  component: lazyScreen(loadAutomaticSplitScreens, 'AutomaticSplitPlanRouteScreen'),
});
